"use client";
import { useNavigate, useParams } from "react-router-dom";
import { use, useEffect, useState } from 'react';
import DataTable from '../../components/base/DataTable';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import { useToast } from '../../components/base/Toast';
import { getData } from '../../services/FetchNodeServices';
import ConfirmDialog from '../../components/base/ConfirmDialog';
import Modal from '../../components/base/Modal';
import SchemaForm from './UserSchemaForm';
import WecDetailsModal from "../../components/base/WecDetailsModal";

export default function superstockistDetails() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [user, setUser] = useState(() => {
        const storedUser = sessionStorage.getItem('user');
        return storedUser ? JSON.parse(storedUser) : null;
    });

    const { showToast, ToastContainer } = useToast();
    const [activeTab, setActiveTab] = useState(user?.role === 'distributor' ? 'retailer' : user?.role === "superStockist" ? 'distributor' : user.role === 'TSM-ASM' ? 'retailer' : 'superStockist');
    const [loading, setLoading] = useState(false);
    const [editingAMC, setEditingAMC] = useState(null);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [categoryFilter, setCategoryFilter] = useState('all');
    const [totalData, setTotalData] = useState(0);
    const [retailerTotal, setRetailerTotal] = useState(0);
    const [distributorsTotal, setDistributorsTotal] = useState(0);
    const [superStockistTotal, setSuperStockistTotal] = useState(0);
    const [tsmAsmTotal, setTsmAsmTotal] = useState(0);
    const [promoterTotal, setPromoterTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // [pageSize]
    const [distributorsData, setDistributorsData] = useState([]);
    const [retailerData, setRetailerData] = useState([]);
    const [promoterData, setPromoterData] = useState([]);
    const [data, setData] = useState([]);
    const [rolePermissions, setRolePermissions] = useState([]);
    const [creatorMap, setCreatorMap] = useState([]);
    const [amcs, setAmcs] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [deletingUser, setDeletingUser] = useState(null);
    const [distributors, setDistributors] = useState(data.filter(user => user?.role === 'distributor'));
    const [retailers, setRetailers] = useState([]);
    const [ref, setRef] = useState(false);
    const [isWecModalOpen, setIsWecModalOpen] = useState(false);
    const [selectedWec, setSelectedWec] = useState(null);

    // Mock data
    const [tsm, setTSM] = useState(data.filter(user => editingAMC?.role === 'TSM-ASM'));
    const [canRead, canWrite, canEdit, canDelete] = (() => {
        // Default admin/distributor/retailer logic
        if (['admin'].includes(editingAMC?.role)) return [true, true, true, true];
        if (['distributor'].includes(editingAMC?.role)) return [true, true, true, true];
        if (['superStockist'].includes(editingAMC?.role)) return [true, true, true, true];
        if (['retailer'].includes(editingAMC?.role)) return [false, false, false, false];
        if (['TSM-ASM'].includes(editingAMC?.role)) return [true, true, true, true];

        // Dynamic staff role permissions
        const modulePerm = rolePermissions?.find(
            (m) => m.module === 'User Management'
        );
        if (!modulePerm) return [false, false, false, false];

        return [
            modulePerm.permissions.includes('read'),
            modulePerm.permissions.includes('write'),
            modulePerm.permissions.includes('edit'),
            modulePerm.permissions.includes('delete'),
        ];
    })();

    useEffect(() => {
        if (id) {
            const fetchSuperStockistData = async () => {
                try {
                    const res = await getData(`api/admin/get-All-Users-By-Admin`);
                    console.log("XXXZZZZZZXXXX:=>", res?.data)
                    if (res?.status) {
                        setCreatorMap(res?.data || []);
                        const user = res?.data?.find((u) => u?._id === id);
                        console.log("XXXZZZZZZXXXX:=>", user)
                        if (user) {
                            setEditingAMC(user);
                        }
                    }
                } catch (err) {
                    console.error('Creator fetch error', err);
                }
            };
            fetchSuperStockistData();
        }
    }, [id])

    // fields

    const superstockistFields = [
        { name: 'ownerName', label: 'Super Stockist Name', type: 'text', required: true },
        { name: 'name', label: 'Company Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'phone', label: 'Mobile', type: 'number', required: true },
        { name: 'password', label: 'Password', type: 'password', required: !editingUser, oldpassword: user.role !== 'distributor' && editingUser?.showpassword },
        { name: 'address', label: 'Address', type: 'textarea', required: true },
        { name: 'gst', label: 'GST', type: 'text', required: false },
        {
            name: 'status', label: 'Status', type: 'select', required: true, options: [
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' }
            ]
        }
    ];

    const distributorFields = [
        { name: 'ownerName', label: 'Distributor Name', type: 'text', required: true },
        { name: 'name', label: 'Company Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'phone', label: 'Mobile', type: 'number', required: true },
        { name: 'password', label: 'Password', type: 'password', required: !editingUser, oldpassword: user.role !== 'distributor' && editingUser?.showpassword },
        { name: 'address', label: 'Address', type: 'textarea', required: true },
        { name: 'gst', label: 'GST', type: 'text', required: false },
        {
            name: 'status', label: 'Status', type: 'select', required: true, options: [
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' }
            ]
        }
    ];

    const retailerFields = [
        { name: 'ownerName', label: 'Retailer Name', type: 'text', required: true },
        { name: 'name', label: 'Store Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'phone', label: 'Mobile', type: 'number', required: true },
        { name: 'password', label: 'Password', type: 'password', required: !editingUser, oldpassword: user.role !== 'retailer' && editingUser?.showpassword },
        { name: 'address', label: 'Address', type: 'textarea', required: false },
        { name: 'gst', label: 'GST', type: 'text', required: false },
        ...(user?.role !== 'distributor' && user?.role !== 'retailer' ? [{
            name: 'DistributorId', label: 'Assigned Distributor', type: 'select', required: true, options:
                user?.role === 'TSM-ASM' ? availableTSMDistributors.filter(d => d.status === 'active') : distributors.filter(d => d.status === 'active')
        }] : []),

        {
            name: 'status', label: 'Status', type: 'select', required: true, options: [
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' }
            ]
        }
    ];

    const promoterFields = [
        // { name: 'ownerName', label: 'Owner Name', type: 'text', required: true },
        { name: 'name', label: 'Promoter Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'phone', label: 'Mobile', type: 'number', required: true },
        { name: 'password', label: 'Password', type: 'password', required: !editingUser, oldpassword: user.role !== 'retailer' && editingUser?.showpassword },
        // { name: 'address', label: 'Address', type: 'textarea', required: false },
        // { name: 'gst', label: 'GST', type: 'text', required: false },
        ...(user?.role !== 'distributor' && user?.role !== 'retailer' ? [{
            name: 'DistributorId', label: 'Assigned Distributor', type: 'select', required: true, options:
                distributors.filter(d => d.status === 'active')
        }] : []),
        ...(user?.role !== 'distributor' && user?.role !== 'retailer' ? [{
            name: 'RetailerId', label: 'Assigned Retailer', type: 'multiselect', required: true, options:
                retailers?.filter(d => d.status === 'active')
        }] : []),

        {
            name: 'status', label: 'Status', type: 'select', required: true, options: [
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' }
            ]
        }
    ];

    const tsmAsmFields = [
        // { name: 'ownerName', label: 'Owner Name', type: 'text', required: true },
        { name: 'name', label: 'TSM/ASM name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'phone', label: 'Mobile', type: 'number', required: true },
        { name: 'password', label: 'Password', type: 'password', required: !editingUser, oldpassword: user.role !== 'retailer' && editingUser?.showpassword },
        // { name: 'address', label: 'Address', type: 'textarea', required: false },
        // { name: 'gst', label: 'GST', type: 'text', required: false },
        ...(user?.role !== 'distributor' && user?.role !== 'retailer' ? [{
            name: 'DistributorId', label: 'Assigned Distributor', type: 'select', required: true, options:
                distributors.filter(d => d.status === 'active')
        }] : []),

        {
            name: 'status', label: 'Status', type: 'select', required: true, options: [
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' }
            ]
        }
    ];

    const superstockistColumns = [
        { key: 'ownerName', title: 'Super Stockist Name', sortable: true },
        { key: 'name', title: 'Company Name', sortable: true },
        { key: 'email', title: 'Email', sortable: true },
        { key: 'phone', title: 'Mobile' },
        { key: 'createrByUserName', title: 'Creater Name', render: (value) => value || 0 },
        { key: 'totalAMCs', title: 'Total WECs', render: (value) => value || 0 },
        { key: 'totalDistributors', title: 'Total Distributors', render: (value) => value || 0 },
        { key: 'totalRetailers', title: 'Total Retailers', render: (value) => value || 0 },
        { key: 'walletBalance', title: 'Wallet Balance', render: (value) => `₹${value.toLocaleString()}` },
        { key: 'createdAt', title: 'Date of Joining', render: (value) => new Date(value).toLocaleDateString('en-IN') },
        {
            key: 'status', title: 'Status', render: (value) => (
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${value === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                    {value.charAt(0).toUpperCase() + value.slice(1)}
                </span>
            )
        }
    ];

    const distributorColumns = [
        { key: 'ownerName', title: 'Distributor Name', sortable: true },
        { key: 'name', title: 'Company Name', sortable: true, render: (value, row) => value || 0, link: (row) => `/SuperstockistDetails/${row?._id}` },
        { key: 'email', title: 'Email', sortable: true },
        { key: 'phone', title: 'Mobile' },
        { key: 'totalRetailers', title: 'Retailers', render: (value) => value || 0 },
        { key: 'totalAMCs', title: 'Total WECs', render: (value) => value || 0 },
        {
            key: 'name', title: 'Total TSM/ASM', render: (value) => {
                if (!value) return '-';

                const creator = creatorMap.filter((u) => u.role === 'TSM-ASM' && u.DistributorId === value);

                if (!creator) return `${value || ''}`;

                return `${creator.length}`;
            }
        },
        { key: 'walletBalance', title: 'Wallet Balance', render: (value) => `₹${value.toLocaleString()}` },
        {
            key: 'createdByEmail', title: 'Creater Name', render: (value) => {
                if (!value?.email) return '-';

                const creator = creatorMap.find(u => u.email === value.email);

                if (!creator) return `${value.name || ''}`;

                return `${creator.name} (${creator.role})`;
            }
        },
        { key: 'createdAt', title: 'Date of Joining', render: (value) => new Date(value).toLocaleDateString('en-IN') },
        {
            key: 'status', title: 'Status', render: (value) => (
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${value === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                    {value.charAt(0).toUpperCase() + value.slice(1)}
                </span>
            )
        }
    ];

    const retailerColumns = [
        { key: 'ownerName', title: 'Retailer Name', sortable: true },
        { key: 'name', title: 'Store Name', sortable: true, render: (value, row) => value || 0, link: (row) => `/SuperstockistDetails/${row?._id}` },
        { key: 'email', title: 'Email', sortable: true },
        { key: 'phone', title: 'Mobile' },

        {
            key: 'name', title: 'Promoter Name',
            render: (value) => {
                if (!value) return '-';

                const creator = creatorMap.find((u) => u.role === 'promoter' && Array.isArray(u.RetailerId) && u.RetailerId.includes(value));

                if (creator) return creator.name;

                return '-';
            }
        },

        ...(user?.role !== 'distributor' && user?.role !== 'retailer' ? [{
            key: 'DistributorId', title: 'Distributor', render: (value) => {
                if (!value) return '-';

                const creator = creatorMap.find((u) => u.role === 'distributor' && u.name.includes(value));

                if (creator) return `${creator.name} (${creator.ownerName})`;

                return '-';
            },
            sortable: true
        }] : []),

        { key: 'totalAMCs', title: 'Total WECs', render: (value) => value || 0 },
        { key: 'walletBalance', title: 'Wallet Balance', render: (value) => `₹${value.toLocaleString()}` },
        {
            key: 'createdByEmail', title: 'Creater Name', render: (value) => {
                if (!value?.email) return '-';

                const creator = creatorMap.find(u => u.email === value.email);

                if (!creator) return `${value.name || ''}`;

                return `${creator.name} (${creator.role})`;
            }
        },
        { key: 'createdAt', title: 'Date of Joining', render: (value) => new Date(value).toLocaleDateString('en-IN') },
        {

            //   key: 'status', title: 'Status', render: (value) => (
            //     <span className={`px-2 py-1 rounded-full text-xs font-medium ${value === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            //       }`}>
            //       {value.charAt(0).toUpperCase() + value.slice(1)}
            //     </span>
            //   )
        }
    ];

    const tsmAsmColumns = [
        { key: 'name', title: 'TSM/ASM Name', sortable: true, render: (value, row) => value || 0, link: (row) => `/SuperstockistDetails/${row?._id}` },
        { key: 'email', title: 'Email', sortable: true },
        { key: 'phone', title: 'Mobile' },
        ...(user?.role !== 'distributor' && user?.role !== 'retailer' ? [{
            key: 'DistributorId', title: 'Distributor', render: (value) => {
                if (!value) return '-';

                const creator = creatorMap.find((u) => u.role === 'distributor' && u.name.includes(value));

                if (creator) return `${creator.name} (${creator.ownerName})`;

                return '-';
            }, sortable: true
        }] : []),
        {
            key: 'email', title: 'Total Retailers', render: (value) => {
                if (!value) return '-';

                const creator = creatorMap.filter((u) => u?.role === 'retailer' && u?.retailerByTSMASM?.email === value);
                // console.log("XXXXXX:=>creatorMap", creatorMap, creator)
                if (creator) return creator?.length;

                return 0;
            }
        },
        // { key: 'totalAMCs', title: 'Total WECs', render: (value) => value || 0 },

        { key: 'walletBalance', title: 'Wallet Balance', render: (value) => `₹${value.toLocaleString()}` },
        { key: 'createdAt', title: 'Date of Joining', render: (value) => new Date(value).toLocaleDateString('en-IN') },
        {

            key: 'status', title: 'Status', render: (value) => (
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${value === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                    {value.charAt(0).toUpperCase() + value.slice(1)}
                </span>
            )
        }
    ];
    // console.log("XXXXXX::=>", retailerColumns)
    const showHierarchyColumns = !['distributor', 'retailer'].includes(user?.role);

    const promoterColumns = [
        { key: 'name', title: 'Promoter Name', sortable: true, render: (value, row) => value || 0, link: (row) => `/SuperstockistDetails/${row?._id}` },
        { key: 'email', title: 'Email', sortable: true, },
        { key: 'phone', title: 'Mobile' },
        ...(showHierarchyColumns ? [
            {
                key: 'DistributorId', title: 'Distributor', render: (value) => {
                    if (!value) return '-';

                    const creator = creatorMap.find(u => u.name === value);

                    if (!creator) return `${value || ''}`;

                    return `${creator?.name} (${creator?.ownerName})`;
                }, sortable: true
            },
            // {
            //     key: 'RetailerId',
            //     title: 'Retailer',
            //     sortable: false,
            //     render: (value) => {
            //         if (!value || value.length === 0) return '-';

            //         return (
            //             <div className="flex flex-wrap gap-1">
            //                 {value.map((r, i) => (
            //                     <span
            //                         key={i}
            //                         className="px-2 py-0.5 text-xs rounded-full bg-indigo-100 text-indigo-800"
            //                     >
            //                         {r}
            //                     </span>
            //                 ))}
            //             </div>
            //         );
            //     }
            // }
        ] : []),
        { key: 'totalAMCs', title: 'Total WECs', render: (value) => value || 0 },
        // { key: 'walletBalance', title: 'Wallet Balance', render: (value) => `₹${value.toLocaleString()}` },
        { key: 'createdAt', title: 'Date of Joining', render: (value) => new Date(value).toLocaleDateString('en-IN') },
        {

            key: 'status', title: 'Status', render: (value) => (
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${value === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                    {value.charAt(0).toUpperCase() + value.slice(1)}
                </span>
            )
        }
    ];

    const wecColumns = [
        { key: 'id', title: 'WEC ID', sortable: true },
        { key: 'customerName', title: 'Customer', sortable: true },
        { key: 'productCategory', title: 'Category' },
        { key: 'productBrand', title: 'Brand' },
        { key: 'productModel', title: 'Model' },
        { key: 'amcAmount', title: 'WEC Amount', render: (value) => `₹${value?.toLocaleString()}` },
        {
            key: 'startDate', title: 'Start Date',
            // render: (value) => new Date(value).toLocaleDateString('en-IN')
        },
        {
            key: 'endDate', title: 'End Date',
            // render: (value) => new Date(value).toLocaleDateString('en-IN')
        },
        {
            key: 'status', title: 'Status', render: (value) => {
                const colors = {
                    active: 'bg-green-100 text-green-800',
                    expiring: 'bg-yellow-100 text-yellow-800',
                    expired: 'bg-red-100 text-red-800',
                    renewed: 'bg-blue-100 text-blue-800'
                };
                return (
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${colors[value] || 'bg-gray-100 text-gray-800'}`}>
                        {value.charAt(0).toUpperCase() + value.slice(1)}
                    </span>
                );
            }
        }
    ];

    if (editingAMC?.role === 'admin') {
        wecColumns.splice(-1, 0,
            {
                key: 'retailerName', title: 'Retailer/Promoter', render: (value, row) => {
                    const retailer = value || '-';
                    const promoter = row?.createByPromoter?.name;

                    return promoter ? `${retailer} / ${promoter}` : retailer;
                }
            },
            { key: 'distributorName', title: 'Distributor' }
        );
    } else if (editingAMC?.role === 'distributor') {
        wecColumns.splice(-1, 0, { key: 'retailerName', title: 'Retailer/Promoter' }, { key: 'distributorName', title: 'Distributor' });
    } else if (editingAMC?.role !== 'retailer' && editingAMC?.role !== 'distributor' && editingAMC?.role !== 'promoter') {
        wecColumns.splice(-1, 0,
            {
                key: 'retailerName',
                title: 'Retailer / Promoter',
                sortable: true,
                render: (value, row) => {
                    const retailer = value || 'N/A';
                    const promoter = row?.createByPromoter?.name;

                    return promoter ? `${retailer} (${promoter})` : retailer;
                }
            },
            { key: 'distributorName', title: 'Distributor' }
        );
    } else if (editingAMC?.role === 'promoter') {
        wecColumns.splice(-1, 0,
            {
                key: 'retailerName',
                title: 'Retailer',
                sortable: true,
                render: (value, row) => {
                    const retailer = value || '-';
                    const promoter = row?.createByPromoter?.name;

                    return promoter ? `${retailer} (${promoter})` : retailer;
                }
            },
        );
    } else if (editingAMC?.role === 'retailer') {
        wecColumns.splice(-1, 0,
            {
                key: 'createByPromoter',
                title: 'Promoter',
                sortable: true,
                render: (value, row) => {
                    // console.log("XXXX::=>" , value , row)
                    const retailer = value?.name || '-';
                    const promoter = row?.createByPromoter?.name;

                    return promoter ? ` ${promoter}` : retailer;
                }
            },
        );
    }

    // wecColumns.push({
    //     key: 'action',
    //     title: 'Action',
    //     render: (value, row) => (
    //         <Button
    //             size="sm"
    //             variant="ghost"
    //             onClick={() => {
    //                 setSelectedWec(row);
    //                 setIsWecModalOpen(true);
    //             }}
    //         >
    //             <i className="ri-eye-line w-4 h-4 flex items-center justify-center text-blue-600"></i>
    //         </Button>
    //     )
    // });

    const fetchAdminData = async () => {
        setLoading(true)
        try {
            const queryParams = new URLSearchParams({
                limit: pageSize.toString(),
                page: currentPage.toString(),
                search: searchTerm || '',
                role: activeTab || '',
                status: statusFilter || ''
            }).toString();

            const response = await getData(`api/admin/getAdminUsersByAdminwithPagination?${queryParams}`);
            console.log('response==>ADMIN', response)
            if (response?.status) {
                setLoading(false)
                if (activeTab === 'distributor') {
                    setTotalData(response.pagination.total);
                    // setRetailerTotal(response.pagination.totalRetailers)

                }
                //  else {
                //   // setRetailerTotal(response.pagination.total)
                // }
                setDistributorsTotal(response.pagination.totalDistributors || 0)
                setSuperStockistTotal(response.pagination.totalSuperStockists || 0)
                // setRetailerTotal(response.pagination.totalRetailers || 0)
                setTsmAsmTotal(response.pagination.totalTSMASM || 0)
                setPromoterTotal(response.pagination.totalPromoters || 0)
                setData(response.data);
                setPage(response.pagination.totalPages);
                setPageSize(response.pagination.pageSize);
                // setTotalData(response.pagination.total);
                // console.log('Fetched Admin Users:', response.data);
                // Optionally update state here
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
            setLoading(false)
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    };

    const fetchAllRetailers = async () => {
        try {
            setLoading(true)
            const queryParams = new URLSearchParams({
                limit: pageSize.toString(),
                page: currentPage.toString(),
                search: searchTerm || '',
                role: 'retailer' || '',
                status: statusFilter || '',
                createdByEmail: editingAMC?.email || '',
            }).toString();

            const response = await getData(`api/admin/getRetailersByAdminwithPagination?${queryParams}`);
            console.log('response==>aaaaaa', response)
            if (response?.status) {
                setLoading(false)
                setRetailerTotal(response.pagination.total);
                if (editingAMC.role !== 'TSM-ASM') {
                    setRetailerData(response?.data)
                }
                setPage(response.pagination.totalPages);
                setPageSize(response.pagination.pageSize);
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
            setLoading(false)
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    };

    const fetchAllDataBySuperStockist = async () => {
        try {
            setLoading(true)
            const queryParams = new URLSearchParams({
                limit: pageSize.toString(),
                page: currentPage.toString(),
                search: searchTerm || '',
                role: 'retailer' || activeTab || '',
                status: statusFilter || '',
                createdByEmail: editingAMC?.email || '',
                createId: editingAMC?._id
            }).toString();

            let response = ''
            if (editingAMC?.role === 'superStockist' && activeTab === 'retailer') {
                response = await getData(`api/admin/getAllUserDataWithPagination?${queryParams}`);
            } else {
                response = await getData(`api/admin/getAllUserDataWithPagination?${queryParams}`);
            }

            console.log('response==>ADMIN==>', editingAMC, response, queryParams)
            if (response?.status) {
                if (activeTab === 'distributor') {
                    setTotalData(response.pagination.total);
                }
                setLoading(false)
                setDistributorsTotal(response.pagination.totalDistributors || 0)
                setSuperStockistTotal(response.pagination.totalSuperStockists || 0)

                setTsmAsmTotal(response.pagination.totalTSMASM || 0)
                setPromoterTotal(response.pagination.totalPromoters || 0)
                setData(response?.data);
                if (editingAMC.role !== 'TSM-ASM') {
                    setRetailerTotal(response.pagination.totalRetailers || 0)
                    setRetailerData(response?.data)
                }
                setPage(response.pagination.totalPages);
                setPageSize(response.pagination.pageSize);
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
            setLoading(false)
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    }

    const fetchAllDataByTSMASM = async () => {
        try {
            setLoading(true)
            const queryParams = new URLSearchParams({
                limit: pageSize.toString(),
                page: currentPage.toString(),
                search: searchTerm || '',
                role: activeTab || '',
                status: statusFilter || '',
                retailerByTSMASM: user?.email || '',
            }).toString();

            const response = await getData(`api/admin/getAllUserDataByTSMASMWithPagination?${queryParams}`);
            console.log('response==>ADMIN==> fetchAllDataByTSMASM=> ', response)
            if (response?.status) {
                if (activeTab === 'distributor') {
                    setTotalData(response.pagination.total);
                }
                setLoading(false)
                setDistributorsTotal(response.pagination.totalDistributors || 0)
                setSuperStockistTotal(response.pagination.totalSuperStockists || 0)
                setTsmAsmTotal(response.pagination.totalTSMASM || 0)
                setPromoterTotal(response.pagination.totalPromoters || 0)
                setData(response.data);
                setPage(response.pagination.totalPages);
                setPageSize(response.pagination.pageSize);
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
            setLoading(false)
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    }

    const fetchAllRetailerDataByTSMASM = async () => {
        try {
            setLoading(true)
            const queryParams = new URLSearchParams({
                limit: pageSize.toString(),
                page: currentPage.toString(),
                search: searchTerm || '',
                role: activeTab || '',
                status: statusFilter || '',
                retailerByTSMASM: editingAMC?.email || '',
            }).toString();

            const response = await getData(`api/admin/getAllRetailerDataByTSMASMWithPagination?${queryParams}`);
            console.log('getAllRetailerDataByTSMASMWithPagination=> ', response)
            if (response?.status) {
                // if (activeTab === 'distributor') {
                //     setTotalData(response.pagination.total);
                // }
                setLoading(false)
                // setDistributorsTotal(response.pagination.totalDistributors || 0)
                // setSuperStockistTotal(response.pagination.totalSuperStockists || 0)
                // setTsmAsmTotal(response.pagination.totalTSMASM || 0)
                // setPromoterTotal(response.pagination.totalPromoters || 0)
                // setData(response.data);
                setRetailerData(response.data)
                setRetailerTotal(response?.pagination?.total || 0)
                setPage(response.pagination.totalPages);
                setPageSize(response.pagination.pageSize);
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
            setLoading(false)
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    }

    const fetchAllDistributorsData = async () => {
        setLoading(true)
        try {
            const queryParams = new URLSearchParams({
                limit: pageSize.toString(),
                page: currentPage.toString(),
                search: searchTerm || '',
                role: 'distributor' || '',
                status: statusFilter || ''
            }).toString();

            const response = await getData(`api/admin/getAdminUsersByAdminwithPagination?${queryParams}`);
            console.log('response==>ADMIN', response)
            if (response?.status) {
                setLoading(false)
                if (activeTab === 'distributor') {
                    setTotalData(response.pagination.total);
                }
                setDistributorsTotal(response.pagination.totalDistributors || 0)
                setSuperStockistTotal(response.pagination.totalSuperStockists || 0)
                setTsmAsmTotal(response.pagination.totalTSMASM || 0)
                setPromoterTotal(response.pagination.totalPromoters || 0)
                if (editingAMC?.role === 'TSM-ASM') {
                    setDistributorsData(response.data.filter((d) => d?.name === editingAMC?.DistributorId));
                }
                setPage(response.pagination.totalPages);
                setPageSize(response.pagination.pageSize);
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
            setLoading(false)
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    };

    const fetchDistributorData = async () => {
        try {
            const response = await getData(`api/admin/getDistributorsByAdmin`);
            // console.log('response==>getDistributorsByAdmin', response)
            if (response?.status) {
                setDistributors(response.data);
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    };

    const fetchAMCs = async () => {
        try {
            let response = ''
            if (editingAMC?.role === 'retailer') {
                response = await getData(`api/amcs/get-amc-by-retailer-with-pagination/${editingAMC?._id}?Role=${editingAMC?.role}&page=${currentPage}&limit=${pageSize}&search=${searchTerm}&status=${statusFilter}&category=${categoryFilter}&brand=${'brandFilter'}&type=${'typeFilter'}`)
            } else if (editingAMC?.role === 'distributor') {
                response = await getData(`api/amcs/get-amc-by-distributor-with-pagination/${editingAMC?._id}?createdByEmail=${editingAMC?.email}&Role=${editingAMC?.role}&page=${currentPage}&limit=${pageSize}&search=${searchTerm}&status=${statusFilter}&category=${categoryFilter}&brand=${'brandFilter'}&type=${'typeFilter'}`);
            } else if (editingAMC?.role === 'promoter') {
                response = await getData(`api/amcs/get-amc-by-distributor-with-pagination/${editingAMC?._id}?createdByPromoter=${editingAMC?.email}&Role=${editingAMC?.role}&page=${currentPage}&limit=${pageSize}&search=${searchTerm}&status=${statusFilter}&category=${categoryFilter}&brand=${'brandFilter'}&type=${'typeFilter'}`);
            } else if (editingAMC?.role === 'superStockist') {
                response = await getData(`api/amcs/get-amc-by-superStockist-with-pagination/${editingAMC?._id}?createdByEmail=${editingAMC?.email}&Role=${editingAMC?.role}&page=${currentPage}&limit=${pageSize}&search=${searchTerm}&status=${statusFilter}&category=${categoryFilter}&brand=${'brandFilter'}&type=${'typeFilter'}`);
            } else {
                response = await getData(`api/amcs/get-amc-by-admin-with-pagination?page=${currentPage}&Role=${editingAMC?.role}&limit=${pageSize}&search=${searchTerm}&status=${statusFilter}&category=${categoryFilter}&brand=${'brandFilter'}&type=${'typeFilter'}`);
            }


            console.log("responseGGG=> response==>", response.pagination)
            if (response?.status === true) {
                setAmcs(response?.data);
                setCurrentPage(response?.pagination?.currentPage || 1);
                setTotalPages(response?.pagination?.totalPages || 1);
                setTotalData(response?.pagination?.totalAMCs || 0);
                // setTotalActive(response?.pagination?.totalActiveAMCs || 0);
                // setTotalExpired(response?.pagination?.totalExpiredAMCs || 0);
                // setTotalExpiringSoon(response?.pagination?.totalExpiringSoonAMCs || 0);
            }

        } catch (error) {
            console.error('Error fetching AMC data:', error);
        }
    }

    const fetchTSMASMData = async () => {
        try {
            const response = await getData(`api/admin/getTSMASMByAdmin`);
            console.log('response==>getDistributorsByAdmin', response)
            if (response?.status) {
                setTSM(response?.data);
            } else {
                console.warn('Failed to fetch admin users:', response.message);
            }
        } catch (error) {
            console.error('Error fetching admin users:', error);
        }
    };


    const getUserAMCs = () => {
        if (editingAMC?.role === 'admin') {
            return amcs;
        } else if (editingAMC?.role === 'distributor') {
            return amcs;
        } else if (editingAMC?.role === 'retailer') {
            return amcs.filter(amc => amc.retailerId === editingAMC?._id);
        } else if (editingAMC?.role === 'promoter') {
            return amcs;
        } else {
            return amcs;
        }
        return [];
    };

    const getTSM = () => {
        if (editingAMC?.role === 'admin') {
            return tsm;
        } else if (editingAMC?.role === 'distributor') {
            return tsm.filter((item) => item?.DistributorId === editingAMC?.name);
        }
        // else if (editingAMC?.role === 'retailer') {
        //     return tsm.filter(amc => amc.retailerId === editingAMC?._id);
        // }
        // else if (editingAMC?.role === 'promoter') {
        //     return tsm;
        // } else {
        //     return tsm;
        // }
        return [];
    };

    const userAMCs = getUserAMCs();

    const TSM = getTSM()

    useEffect(() => {
        if (editingAMC?.role === 'distributor') {
            fetchAllRetailers();
        } else if (editingAMC?.role === 'superStockist') {
            fetchAllDataBySuperStockist();
        }
        else if (editingAMC?.role === 'TSM-ASM') {
            fetchAllDataByTSMASM();
            fetchAllRetailerDataByTSMASM()
        } else {
            fetchAdminData();
        }

        fetchAllDistributorsData();
        if (editingAMC) {
            fetchAMCs()
            fetchTSMASMData()
            fetchAllDataBySuperStockist()
        }
        if (editingAMC?.role === 'retailer') {
            const retailerName = editingAMC?.name?.toLowerCase();

            const promoters = creatorMap.filter((u) =>
                u.role === "promoter" &&
                u.RetailerId?.some(
                    (r) => r.toLowerCase() === retailerName
                )
            );
            setPromoterData(promoters);
        } else if (editingAMC?.role !== "promoter") {
            setPromoterData([]);
        }

    }, [currentPage, searchTerm, statusFilter, activeTab, editingAMC, ref]);

    const handleEdit = (user) => {
        // Remove password from editing data for security
        const { password, ...userWithoutPassword } = user;
        console.log("DDD:==>user", data, password);
        setEditingUser({ ...userWithoutPassword, oldCreatedByEmail: userWithoutPassword?.createdByEmail });
        setIsModalOpen(true);
    };

    const handleDelete = (user) => {
        setDeletingUser(user);
        setIsDeleteDialogOpen(true);
    };
    console.log("editingAMC=>", editingAMC)
    const renderActions = (record) => (
        <div className="flex space-x-2">
            {canEdit && <Button
                size="sm"
                variant="ghost"
                onClick={() => { handleEdit(record), setActiveTab(record?.role) }}
            >
                <i className="ri-edit-line w-4 h-4 flex items-center justify-center"></i>
            </Button>}
            {canDelete && <Button
                size="sm"
                variant="ghost"
                onClick={() => handleDelete(record)}
            >
                <i className="ri-delete-bin-line w-4 h-4 flex items-center justify-center text-red-600"></i>
            </Button>}
        </div>
    );

    const renderWecActions = (record) => (
        <div className="flex space-x-2">
            <Button
                size="sm"
                variant="ghost"
                onClick={() => {
                    setSelectedWec(record);
                    setIsWecModalOpen(true);
                }}
            >
                <i className="ri-eye-line w-4 h-4 flex items-center justify-center text-blue-600"></i>
            </Button>
        </div>
    );

    const handleConfirmDelete = async () => {
        setLoading(true);
        try {
            // await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
            const respons = await getData(`api/admin/delete-admin-user-by-admin/${deletingUser?._id}`);
            if (respons.status === true) {
                showToast('deleted successfully', 'success');
                setIsDeleteDialogOpen(false);
                setDeletingUser(null);
                setLoading(false);
                setRef(!ref)
                if (user?.role === 'admin') {
                    fetchAdminData()
                }
                if (user?.role === 'distributor') {
                    fetchAllRetailers()
                }
                if (user?.role === 'retailer') {
                    fetchDistributorData()
                }

            } else {
                showToast('Delete failed', 'error');
                setLoading(false);
            }

        } catch (error) {
            showToast('Delete failed', 'error');
        } finally {
            setLoading(false);
        }
    };

    const getUserTypeLabel = (tab) => {
        switch (tab) {
            case 'distributor':
                return 'Add Distributor';
            case 'superStockist':
                return ' Add Super Stockists';
            case 'retailer':
                return 'Add Retailer';
            case 'promoter':
                return 'Add Promoters';
            case 'TSM-ASM':
                return 'Add TSM/ASM';
            default:
                return 'Add User';
        }
    };

    const getuserFields = (tab) => {
        switch (tab) {
            case 'distributor':
                return distributorFields;
            case 'superStockist':
                return superstockistFields;
            case 'retailer':
                return retailerFields;
            case 'promoter':
                return promoterFields;
            case 'TSM-ASM':
                return tsmAsmFields;
            default:
                return 'User';
        }
    };

    const handleSubmit = async (formData) => {
        setLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call

            // Set default date of joining if not provided
            if (!formData.dateOfJoining) {
                formData.dateOfJoining = new Date().toISOString().split('T')[0];
            }

            if (activeTab === 'distributor') {
                if (editingUser) {
                    setDistributors(prev => prev.map(d => d.id === editingUser.id ? { ...d, ...formData } : d));
                    showToast('Distributor updated successfully', 'success');
                } else {
                    const newDistributor = {
                        id: Date.now().toString(),
                        ...formData,
                        walletBalance: 0,
                        joinedDate: formData.dateOfJoining,
                        totalRetailers: 0,
                        totalAMCs: 0
                    };
                    setDistributors(prev => [...prev, newDistributor]);
                    showToast('Distributor added successfully', 'success');
                }
            } else {
                const distributorId = user?.role === 'distributor' ? user.id : formData.distributorId;
                const distributor = distributors.find(d => d.id === distributorId);

                if (editingUser) {
                    setRetailers(prev => prev.map(r => r._id === editingUser._id ? {
                        ...r,
                        ...formData,
                        distributorId,
                        assignedDistributor: distributor?.name || ''
                    } : r));
                    showToast('Retailer updated successfully', 'success');
                } else {
                    const newRetailer = {
                        id: Date.now().toString(),
                        ...formData,
                        distributorId,
                        assignedDistributor: distributor?.name || '',
                        walletBalance: 0,
                        joinedDate: formData.dateOfJoining,
                        totalAMCs: 0
                    };
                    setRetailers(prev => [...prev, newRetailer]);
                    showToast('Retailer added successfully', 'success');
                }
            }

            setIsModalOpen(false);
        } catch (error) {
            showToast('Operation failed', 'error');
        } finally {
            setLoading(false);
        }
    };

    console.log("XXXXXXX::=> XXXXXXX::=>editingAMC", retailerData, editingAMC, promoterData); // "1"   

    return (
        <div className="p-4 sm:p-6 space-y-4 sm:space-y-6 max-w-full overflow-hidden">
            <ToastContainer />
            {editingAMC && (
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                    <div className="flex items-center justify-between mb-6">
                        <button
                            onClick={() => navigate(-1)}
                            className="flex items-center gap-1 px-2 py-1 rounded-full 
                                       bg-gradient-to-r from-indigo-500 to-blue-600 
                                       text-white text-sm font-medium shadow-md
                                       hover:from-indigo-600 hover:to-blue-700 
                                       hover:shadow-lg active:scale-95 transition-all duration-200"
                        >
                            <i className="ri-arrow-left-line text-lg"></i>
                            Go Back
                        </button>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <div>
                                <span>Role:- </span>
                                <span
                                    className={`px-3 py-1 text-xs font-medium rounded-full ${editingAMC?.status === "active"
                                        ? "bg-green-100 text-green-700"
                                        : "bg-red-100 text-red-700"
                                        }`}
                                >
                                    {editingAMC?.role}
                                </span>
                            </div>
                            <span
                                className={`px-3 py-1 text-xs font-medium rounded-full ${editingAMC?.status === "active"
                                    ? "bg-green-100 text-green-700"
                                    : "bg-red-100 text-red-700"
                                    }`}
                            >
                                {editingAMC?.status}
                            </span>
                        </div>
                    </div>

                    <div className="flex items-center justify-between mb-6">
                        <div>
                            {editingAMC?.ownerName && <h2 className="text-xl font-semibold text-gray-900">
                                {editingAMC?.ownerName}
                            </h2>}
                            {editingAMC?.name && <p className="text-sm text-gray-500">{editingAMC?.name}</p>}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-sm">

                        {editingAMC?.email && <div className="flex items-start space-x-3">
                            <i className="ri-mail-line text-blue-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Email</p>
                                <p className="text-gray-900 font-medium">{editingAMC?.email}</p>
                            </div>
                        </div>}

                        {editingAMC?.phone && <div className="flex items-start space-x-3">
                            <i className="ri-phone-line text-green-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Mobile</p>
                                <p className="text-gray-900 font-medium">{editingAMC?.phone}</p>
                            </div>
                        </div>}

                        {editingAMC?.address && <div className="flex items-start space-x-3">
                            <i className="ri-map-pin-line text-red-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Address</p>
                                <p className="text-gray-900 font-medium">
                                    {editingAMC?.address || "N/A"}
                                </p>
                            </div>
                        </div>}

                        {editingAMC?.role !== 'promoter' && <div className="flex items-start space-x-3">
                            <i className="ri-wallet-3-line text-yellow-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Wallet Balance</p>
                                <p className="text-lg font-semibold text-gray-900">
                                    ₹{editingAMC?.walletBalance?.toLocaleString()}
                                </p>
                            </div>
                        </div>}

                        <div className="flex items-start space-x-3">
                            <i className="ri-calendar-line text-purple-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Date of Joining</p>
                                <p className="text-gray-900 font-medium">
                                    {new Date(editingAMC?.createdAt).toLocaleDateString("en-IN")}
                                </p>
                            </div>
                        </div>

                        {editingAMC?.totalDistributors > 0 && <div className="flex items-start space-x-3">
                            <i className="ri-team-line text-indigo-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Total Distributors</p>
                                <p className="text-gray-900 font-medium">{editingAMC?.totalDistributors}</p>
                            </div>
                        </div>}
                        {editingAMC?.role === 'TSM-ASM' && <div className="flex items-start space-x-3">
                            <i className="ri-team-line text-indigo-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Total Distributors</p>
                                <p className="text-gray-900 font-medium">{distributorsData?.length}</p>
                            </div>
                        </div>}


                        {editingAMC?.totalRetailers || retailerData.length > 0 && <div className="flex items-start space-x-3">
                            <i className="ri-store-2-line text-pink-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Total Retailers</p>
                                <p className="text-gray-900 font-medium">{editingAMC?.totalRetailers || retailerData?.length}</p>
                            </div>
                        </div>}

                        {editingAMC?.totalAMCs > 0 && editingAMC?.role !== 'TSM-ASM' &&
                            <div className="flex items-start space-x-3">
                                <i className="ri-file-list-3-line text-cyan-500 text-lg"></i>
                                <div>
                                    <p className="text-gray-500">Total WECs</p>
                                    <p className="text-gray-900 font-medium">{editingAMC?.totalAMCs}</p>
                                </div>
                            </div>}

                        {editingAMC?.role === 'promoter' && <div className="flex items-start space-x-3">
                            <i className="ri-file-list-3-line text-cyan-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Total WECs</p>
                                <p className="text-gray-900 font-medium">{userAMCs?.length || 0}</p>
                            </div>
                        </div>}
                        {editingAMC?.role === 'distributor' && <div className="flex items-start space-x-3">
                            <i className="ri-file-list-3-line text-cyan-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Total TSM/ASM</p>
                                <p className="text-gray-900 font-medium">{TSM?.length || 0}</p>
                            </div>
                        </div>}

                        {editingAMC?.role === 'retailer' && <div className="flex items-start space-x-3">
                            <i className="ri-file-list-3-line text-cyan-500 text-lg"></i>
                            <div>
                                <p className="text-gray-500">Total Promoter</p>
                                <p className="text-gray-900 font-medium">{promoterData?.length || 0}</p>
                            </div>
                        </div>}

                    </div>
                </div>
            )}

            {/*Distributor Data Table */}
            {distributorsData && distributorsData.length > 0 && user.role === 'admin' && editingAMC?.role !== 'distributor' && editingAMC?.role === 'TSM-ASM' && editingAMC?.role !== 'retailer' && editingAMC?.role !== 'promoter' && <>
                <h2 className="text-xl font-semibold text-gray-900">
                    Total Distributor ({editingAMC?.role === 'TSM-ASM' ? distributorsData.length : distributorsTotal})
                </h2>

                <DataTable
                    data={distributorsData}
                    columns={distributorColumns}
                    loading={loading}
                    actions={canEdit === true || canDelete === true ? user.role === 'distributor' && activeTab === 'TSM-ASM' ? '' : renderActions : ''}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={page}
                    pageSize={pageSize}
                />
            </>}

            {/*Retailer Data Table */}
            {
                retailerData && retailerData?.length > 0 && <>
                    <h2 className="text-xl font-semibold text-gray-900">
                        Total Retailer ({retailerTotal})
                    </h2>

                    <DataTable
                        data={retailerData}
                        columns={retailerColumns}
                        loading={loading}
                        actions={canEdit === true || canDelete === true ? user.role === 'distributor' && activeTab === 'TSM-ASM' ? '' : renderActions : ''}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={page}
                        pageSize={pageSize}
                    />
                </>
            }

            {
                promoterData && promoterData?.length > 0 && editingAMC?.role !== 'promoter' && <>
                    <h2 className="text-xl font-semibold text-gray-900">
                        Total Promoter ({promoterData?.length})
                    </h2>

                    <DataTable
                        data={promoterData}
                        columns={promoterColumns}
                        loading={loading}
                        actions={canEdit === true || canDelete === true ? user.role === 'distributor' && activeTab === 'TSM-ASM' ? '' : renderActions : ''}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={page}
                        pageSize={pageSize}
                    />
                </>
            }

            {
                userAMCs && userAMCs?.length > 0 && editingAMC?.role !== 'TSM-ASM' && <>
                    <h2 className="text-xl font-semibold text-gray-900">
                        Total WEC ({totalData})
                    </h2>

                    <DataTable
                        data={userAMCs}
                        columns={wecColumns}
                        actions={renderWecActions}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        total={totalData}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages}
                    />
                </>
            }

            {
                TSM && TSM?.length > 0 && <>
                    <h2 className="text-xl font-semibold text-gray-900">
                        Total TSM ({TSM?.length})
                    </h2>
                    <DataTable
                        data={TSM}
                        columns={tsmAsmColumns}
                        // actions={renderActions}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        total={totalData}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages}
                    />
                </>
            }
            {/* Add/Edit Modal */}
            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={`${editingUser ? 'Edit' : ''} ${getUserTypeLabel(activeTab)}`}
                size="lg"
            >
                <SchemaForm
                    fields={
                        getuserFields(activeTab)            // activeTab === 'distributor' ? distributorFields : retailerFields
                    }
                    setRetailers={setRetailers || []}
                    retailers={retailers || []}
                    initialData={editingUser || {}}
                    distributors={distributors}
                    editingUser={editingUser}
                    onSubmit={handleSubmit}
                    setIsModalOpen={setIsModalOpen}
                    activeTab={activeTab}
                    setRef={setRef}
                    ref={ref}
                    onCancel={() => setIsModalOpen(false)}
                    loading={loading}
                    fetchAdminData={user?.role === 'distributor' ? fetchAllRetailers : user?.role === 'superStockist' ? fetchAllDataBySuperStockist : user?.role === 'TSM-ASM' ? fetchAllDataByTSMASM : fetchAdminData}
                />
            </Modal>

            <ConfirmDialog
                isOpen={isDeleteDialogOpen}
                onClose={() => setIsDeleteDialogOpen(false)}
                onConfirm={handleConfirmDelete}
                title="Delete User"
                message={`Are you sure you want to delete ${deletingUser?.name}? This action cannot be undone.`}
                confirmText="Delete"
                variant="danger"
                loading={loading}
            />

            {/* WEC Details Modal */}
            <WecDetailsModal
                isOpen={isWecModalOpen}
                onClose={() => setIsWecModalOpen(false)}
                wec={selectedWec}
            />

        </div >
    );
}
